import { useEffect, useState } from 'react'
import { getInternalUserId } from '@/lib/create-analysis'

const STORAGE_KEY = 'imki-internal-user-id'

function readCached(): string | null {
  if (typeof window === 'undefined') return null
  try { return window.localStorage.getItem(STORAGE_KEY) } catch { return null }
}

function writeCached(id: string) {
  if (typeof window === 'undefined') return
  try { window.localStorage.setItem(STORAGE_KEY, id) } catch { /* quota */ }
}

export function clearCachedInternalUserId() {
  cachedId = null
  if (typeof window === 'undefined') return
  try { window.localStorage.removeItem(STORAGE_KEY) } catch { /* noop */ }
}

// Persisted to localStorage so a hard-nav reload (ClientLayoutRouter forces
// MPA navigation when offline) picks up the id synchronously before first
// paint. Without this, resolving the id can stall without network and every
// page that keys SQLite queries off internal_user_id shows skeletons forever.
//
// The cache is cleared centrally from AuthProvider.signOut via
// clearCachedInternalUserId().
let cachedId: string | null = readCached()

export function useCurrentInternalUserId(): string | null {
  const [id, setId] = useState<string | null>(cachedId)

  useEffect(() => {
    if (cachedId) return
    // getInternalUserId() reads the persisted JWT (no network, never hangs) —
    // see auth-token.ts. Awaiting getSession() here could stall forever offline
    // with an expired token, stranding every id-keyed query on a skeleton.
    void getInternalUserId().then((resolved) => {
      if (resolved) {
        cachedId = resolved
        writeCached(resolved)
        setId(resolved)
      }
    })
  }, [])

  return id
}
